<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="resetForm"
  >
    <a-form ref="formRef" :model="formState" :rules="rules">
      <a-form-item label="密码" name="password">
        <a-input v-model:value="formState.password" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";
import { saveOrUpdateUser } from "@/request/view/repair";
import { useStore } from "vuex";
import { Toast } from "@/utils";

export default defineComponent({
  setup(props, context) {
    const formRef = ref();
    const store = useStore();
    const modalConfig = reactive({
      title: "修改密码",
      visible: false,
    });

    const formState = reactive({
      password: null,
      id: null,
    });

    const rules = {
      password: [
        {
          required: true,
          message: "请输入密码",
          trigger: "blur",
          type: "string",
        },
      ],
    };

    const resetForm = () => {
      formState.id = null;
      formState.password = null;
      formRef.value.clearValidate();
    };

    const handleOk = () => {
      formRef.value
        .validate()
        .then(() => {
          saveOrUpdateUser(formState).then((res) => {
            let type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            if (res.code === 200 && res.message === "成功") {
              resetForm();
              modalConfig.visible = false;
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const showModal = (e) => {
      formState.id = e.id;
      modalConfig.visible = true;
    };

    return {
      formRef,
      modalConfig,
      handleOk,
      formState,
      rules,
      showModal,
      resetForm,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
